import React from "react";
import SignInForm from "../Components/Landing/SignInForm";

export default function SignIn() {
  return (
    <div className="Landing-Container signIn-container">
      <SignInForm />
    </div>
  );
}
